export const EmptyPanelPlaceholder = () => (
  <div className={'flex h-[196px] w-full items-center justify-center border-2 border-dashed border-blue-200'}>
    Drop here
  </div>
)
